/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import Subheader from "layouts/pages/profile/profile-overview/Subheader";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftSnackbar from "components/SoftSnackbar";
import TutorialSidebar from "./tutorial/tutorial";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
//import Footer from "examples/Footer";
import Footer from "layouts/authentication/components/Footer";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";
import PlaceholderCard from "examples/Cards/PlaceholderCard";
import defaultDoughnutChartData from "layouts/pages/charts/data/defaultDoughnutChartData";
import ChangePassword from "layouts/pages/account/settings/components/ChangePassword";
import DeleteAccount from "layouts/pages/account/settings/components/DeleteAccount";
import Logout from "layouts/pages/account/settings/components/Logout";
import Authentication from "layouts/pages/account/settings/components/Authentication";
import AutoDeletePatients from "./autoDelete/autoDelete";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import SoftInput from "components/SoftInput";
import SeperatorTimeframe from "./seperators/seperatorSelect";
import SeperatorNotes from "./seperators/seperatorNotes";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import AddToQueueOutlinedIcon from '@mui/icons-material/AddToQueueOutlined';
import GetAppOutlinedIcon from '@mui/icons-material/GetAppOutlined';
import SeperatorEmail from "./seperators/seperatorEmail";

// Overview page components
import Header from "layouts/pages/profile/components/Header";
import PlatformSettings from "layouts/pages/profile/profile-overview/components/PlatformSettings";
import LatestVisits from "./lastVisits/lastVisits";
import Pages from "layouts/applications/analytics/components/Pages";
import NotLoggedIn from "examples/noUser/notLoggedIn";

import { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, collection, updateDoc, increment } from "firebase/firestore";
import FreeTrialPrompt from "examples/NotLoggedIn/freeTrial";

// Images
import DefaultDoughnutChart from "examples/Charts/DoughnutCharts/DefaultDoughnutChart";
import SoftButton from "components/SoftButton";
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import SoftSelect from "components/SoftSelect";
import { Tooltip } from "@mui/material";
import SoftBadge from "components/SoftBadge";
import Checkbox from "@mui/material/Checkbox";
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import Joyride from 'react-joyride';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

function Overview() {
  const [userAudioUsage, setUserAudioUsage] = useState(0);
  const [subscriptionEndDate, setSubscriptionEndDate] = useState("");
  const [userIdentification, setUserIdentification] = useState("");
  const [userSubscriptionStatus, setUserSubscriptionStatus] = useState(true)
  const [openTODO, setOpenTODO] = useState(false);
  const [selectedTimeFrame, setSelectedTimeFrame] = useState('Last 12 Hours');
  const [todoNotesContent, setTodoNotesContent] = useState("");
  const [openTODOContent, setOpenTODOContent] = useState(false);
  const [copyAllTemplate, setCopyAllTemplate] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [emailSubject, setEmailSubject] = useState('');
  const [emailSenderName, setEmailSenderName] = useState('');
  const [patientEmail, setPatientEmail] = useState('');
  const [agreementEmail, setAgreementEmail] = useState(false);
  const [senderName, setSenderName] = useState('');
  const [senderEmail, setSenderEmail] = useState('');
  const [user, setUser] = useState(null);
  const [currentUserSubscription, setCurrentUserSubscription] = useState(null);
  //const navigate = useNavigate();

  const [isTutorialOpen, setTutorialOpen] = useState(false);
  const [isJoyrideOpen, setIsJoyrideOpen] = useState(false);
  const [showTutorialPrompt, setShowTutorialPrompt] = useState(false);

  const handleToggleTutorial = () => {
      setTutorialOpen(!isTutorialOpen);
  };

  {/*const goToTutorial = () => {
    navigate('/dashboards/default'); 
  };*/}


  const handleStartTutorial = () => {
    setIsJoyrideOpen(true);
    setShowTutorialPrompt(false);
    // Optionally update the firstLogin to false here or elsewhere based on your application flow
  };
  
  const handleSkipTutorial = () => {
    setShowTutorialPrompt(false);
  };
  

  useEffect(() => {
    if (user) {
      const db = getFirestore();
      const userRef = doc(db, "users", user.uid);

      getDoc(userRef).then(docSnap => {
        if (docSnap.exists()) {
          const userData = docSnap.data();
          // Check if the firstLogin field exists and is true
          if (userData.firstLogin === true) {
            setShowTutorialPrompt(true); // Open tutorial if first login

            // Update firstLogin to false after checking
            updateDoc(userRef, {
              firstLogin: false
            });
          }
        }
      }).catch(error => {
        console.error("Error fetching user data:", error);
      });
    }
  }, [user]);
  

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
    if (user) {
        const fetchUserSubscription = async () => {
            try {
                const db = getFirestore();
                const userSubDoc = collection(db, 'customerDetails', user.uid, 'subscriptions'); 
                const q = query(userSubDoc, where("status", "in", ["active", "trialing"]));
                const querySnapshot = await getDocs(q);
                let latestSubscription = null;

                querySnapshot.forEach((doc) => {
                if (!latestSubscription || doc.data().current_period_start.seconds > latestSubscription.current_period_start.seconds) {
                    latestSubscription = doc.data();
                }
                });

                setCurrentUserSubscription(latestSubscription.items[0].price.product.name);
                console.log("user subscription: ", latestSubscription.items[0].price.product.name);
            } catch (error) {
                console.error("Error fetching user subscription:", error);
                setCurrentUserSubscription(null);
            }   
        };
        fetchUserSubscription();
    }
    });
  }, []);

  const handleToggleTODO = () => {
    setOpenTODO(!openTODO);
  };

  const handleToggleEmail = () => {
    setOpenEmail(!openEmail);
  };

  useEffect(() => {
    const auth = getAuth(); 
    const db = getFirestore();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
            const fetchSenderDetails = async () => {
                const userRef = doc(db, "users", user.uid);
                try {
                    const docSnap = await getDoc(userRef);
                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        setSenderName(data.senderName || '');
                        setSenderEmail(data.senderEmail || '');
                    } else {
                        console.log("No sender details found");
                    }
                } catch (error) {
                    console.error("Error fetching sender details: ", error);
                }
            };
            setUser(user);

            fetchSenderDetails();
        }
    });

    return () => unsubscribe();
  }, []); 

  const handleTodoNotesChange = (event) => {
    setTodoNotesContent(event.target.value);
  };

  const handleSelectChange = selectedOption => {
    setSelectedTimeFrame(selectedOption ? selectedOption.value : '');
  };

  const handleEmailSubjectChange = (e) => {
    setEmailSubject(e.target.value);
  };

  const handlePatientEmailChange = (e) => {
      setPatientEmail(e.target.value);
  };

  const handleSetAgreement = (e) => {
      setAgreementEmail(e.target.checked);
  };

  const getTimeframeStartTimestamp = (selectedTimeFrame) => {
    const now = new Date();
    switch (selectedTimeFrame) {
      case "Past 4 Hours":
        return new Date(now.getTime() - (4 * 60 * 60 * 1000));
      case "Past 8 Hours":
        return new Date(now.getTime() - (8 * 60 * 60 * 1000));
      case "Past 12 Hours":
        return new Date(now.getTime() - (12 * 60 * 60 * 1000));
      case "Past 24 Hours":
        return new Date(now.getTime() - (24 * 60 * 60 * 1000));
      case "Past 48 Hours":
        return new Date(now.getTime() - (48 * 60 * 60 * 1000));
      case "Past 72 Hours":
        return new Date(now.getTime() - (72 * 60 * 60 * 1000));
      case "Past 4 Days":
        return new Date(now.getTime() - (96 * 60 * 60 * 1000));
      case "Past 7 Days":
        return new Date(now.getTime() - (168 * 60 * 60 * 1000));  
      default:
        return new Date(now.getTime() - (12 * 60 * 60 * 1000));
    }
  };

  const fetchAndDisplayTodoNotes = async () => {
    if (!selectedTimeFrame) return;

    const db = getFirestore();
    const auth = getAuth();
    const user = auth.currentUser;
    const startTime = getTimeframeStartTimestamp(selectedTimeFrame);
    const q = query(collection(db, "users", user.uid, "tdNotes"), where("createdAt", ">=", startTime));

    try {
        const querySnapshot = await getDocs(q);
        const notesContent = querySnapshot.docs
            .map(doc => {
              const patientName = doc.id;
              const visitName = doc.data().visitName;
              const response = doc.data().content.response;
              return `Patient Name: ${patientName}\nVisit Name: ${visitName}\n\nPlan:\n\n${response}\n\n================\n`;
            })
            .join("\n"); 

        setTodoNotesContent(notesContent);
        setOpenTODOContent(true);
    } catch (error) {
        console.error("Error fetching TODO notes:", error);
    }
  };

  const handleCopyTodoNotes = async () => {
    try {
        await navigator.clipboard.writeText(todoNotesContent);
        setCopyAllTemplate(true);

        setTimeout(() => {
            setCopyAllTemplate(false);
        }, 2000);
        console.log("To-Do notes copied to clipboard.");
    } catch (error) {
        console.error("Failed to copy To-Do notes:", error);
        // Optionally, show an error message to the user
    }
  };

  const handleSendEmail = async () => {
    if ((!patientEmail || patientEmail.trim() === '')) {
        Swal.fire({
            icon: 'warning',
            title: 'Missing Receiver Email',
            text: 'Please enter the email of the receiver.',
            confirmButtonColor: '#344767',
            confirmButtonText: 'OK'
        });
        return; 
    }

    const emailContent = todoNotesContent;
    const emailsSubject = emailSubject || "";
    const sendersName = emailSenderName || senderName;

    // Construct the payload
    const payload = {
        subject: emailsSubject,
        content: emailContent,
        senderName: sendersName,
        patientsEmal: patientEmail
    };

    try {
        const response = await fetch('https://services.leadconnectorhq.com/hooks/scTZfdVrJb3bMVHNemTZ/webhook-trigger/vfPFl5aV4ugN97qY5Usc', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        //console.log("Email sent successfully to the webhook.");
        //setEmailSentSuccess(true);
        //setTimeout(() => setEmailSentSuccess(false), 5000); 
        showSnackbar("dark", "email" ,"Email is sent to receiver!", "Tell receiver to see spam folder as well.");
        setTimeout(() => {
          hideSnackbar();
        }, 5000);
    } catch (error) {
        console.error("Error sending email to the webhook:", error);
        // Handle error, e.g., showing an error message
    }
  };

  const [snackbar, setSnackbar] = useState({
    show: false,
    message: "",
    title: "",
  });
  
  const showSnackbar = (color, icon, title, message ) => {
    setSnackbar({ show: true, color, icon, title, message: `${message}`});
  };

  const hideSnackbar = () => {
    setSnackbar({ ...snackbar, show: false });
  };


  const formatFirebaseTimestamp = (timestamp) => {
    if (!timestamp) return '';
  
    const date = timestamp.toDate(); // Convert to JavaScript Date object
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // JavaScript months are 0-indexed.
    const year = date.getFullYear();
  
    return `${day}/${month}/${year}`;
  };


  const Profiledata = async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    const db = getFirestore();
    setUserIdentification(user.uid);

    if (user) {
      const userRefAudio = doc(db, "users", user.uid);
      const userEndingSubscription = collection(db, "customerDetails", user.uid, "subscriptions");

      const userAudio = await getDoc(userRefAudio);
      const userEnding = await getDocs(userEndingSubscription);

      if (userAudio.exists() && userAudio.data().totalSeconds !== undefined) {
        const userAudiodata = userAudio.data();
        setUserAudioUsage(userAudiodata.totalSeconds);
      } else {
        setUserAudioUsage(0);
      }
      {/*if (!userEnding.empty) {
        const userEndingData = userEnding.docs[0];
        const formattedDate = formatFirebaseTimestamp(userEndingData.data().current_period_end);
        setSubscriptionEndDate(formattedDate);            
      } else {
        console.log("No such document with user ending subscription data");
      }*/}
    }
  };

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        const db = getFirestore();
        const userSubsRef = collection(db, "customerDetails", user.uid, "subscriptions");
        const querySnapshot = await getDocs(userSubsRef);
  
        let foundActiveOrTrialing = false; 
        let latestSubscriptionEndDate = null;
        let latestStartDate = new Date(0); 
  
        if (!querySnapshot.empty) {
          querySnapshot.forEach((doc) => {
            const subscriptionData = doc.data();
            const startDate = subscriptionData.current_period_start.toDate();
            if (["active", "trialing"].includes(subscriptionData.status) && startDate > latestStartDate) {
              latestStartDate = startDate;
              latestSubscriptionEndDate = subscriptionData.current_period_end;
              foundActiveOrTrialing = true;
            }
          });
        }
        if (latestSubscriptionEndDate) {
          const formattedDate = formatFirebaseTimestamp(latestSubscriptionEndDate);
          setSubscriptionEndDate(formattedDate);
        } else {
          console.log("No active/trialing subscriptions found.");
        }
        setUserSubscriptionStatus(foundActiveOrTrialing); // Set subscription status based on flag
  
      } else {
        setUserSubscriptionStatus(false);
        setSubscriptionEndDate("");
      }
    });
  }, []);
  

  //const hasActiveOrTrialSubscription = ["active", "trialing"].includes(userSubscriptionStatus);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, now fetch data
        Profiledata(user);
      } else {
        // User is signed out
        // Handle the signed-out state appropriately
      }
    });
  
    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  const steps = [
    {
      target: '.joyride-recent-visits',
      title: 'Recent Client/Patient Visits',
      content: 'This section provides a quick overview of your most recent interactions. For each client or patient encounter, you can see their name, the date and hour of their visit, and the duration of that visit.',
      placement: 'top'
    },
    {
      target: '.joyride-audio-usage',
      title: 'Monthly Usage Overview',
      content: 'This doughnut chart visualizes your monthly audio usage. Hover over the chart segments to see the exact number of hours you have utilized this month and the hours remaining. The chart also displays the date your subscription will renew each month.',
      placement: 'top'
    },
    {
      target: '.joyride-auto-delete',
      title: 'Manage Patient Data Storage',
      content: 'Here you can control the duration for which patient data is retained. By default, patient records are automatically deleted 30 days after their creation. You can adjust this period using the selector here to meet your specific compliance and data management needs. Remember to save your configuration after making changes.',
      placement: 'top'
    },
    {
      target: '.joyride-summary-generator',
      title: 'Summary Generator for Patient Encounters',
      content: 'This feature allows you to retrieve and manage to-do/task notes generated from each patient encounter. Select a timeframe—up to a maximum of 7 days—to view all generated notes. Once retrieved, you can copy these notes for your records, use them as needed, or directly send them via email through our application. For a detailed guide on how to maximize the use of this tool, please visit our tutorials page.',
      placement: 'top',
    },
    {
      target: '.joyride-support-ticket',
      title: 'Support Ticket System',
      content: 'Need help? Use our support ticket system to contact our support team. You can access it at any time from this button.',
      placement: 'top',
    }
  ];
  


  return (
    <DashboardLayout>
      <Header />
      {userSubscriptionStatus ? (   
        <><SoftBox mt={4} mb={3}>
                <SoftBox pb={4} display="flex" flexDirection="column" justifyContent="center" alignItems="center" className="joyride-summary-generator" >
                  <Card sx={{ width: '90%', margin: '0 auto' }} >
                    <SoftBox p={2} px={4} display="flex" justifyContent="space-between" alignItems="center" >
                      <SoftTypography variant="h6" >
                        Patient Plan&apos;s Summary Generator
                      </SoftTypography>
                      <SoftButton onClick={handleToggleTODO} variant="contained" color="dark" startIcon={ openTODO ? < CloseOutlinedIcon/> : < AddToQueueOutlinedIcon /> } >
                        { openTODO ? "Close Summary Generator" : "Open Summary Generator"} 
                      </SoftButton>
                    </SoftBox>
                    { openTODO && (
                      <>
                        {/*<SoftBox display="flex" justifyContent="center" p={1} >
                          <SoftTypography onClick={handleToggleTutorial} variant="button" color="text" >
                            Open Tutorial
                          </SoftTypography>
                        </SoftBox>
                    <TutorialSidebar open={isTutorialOpen} onClose={handleToggleTutorial} />  */}
                        <SoftBox py={2} >
                          < SeperatorTimeframe />
                        </SoftBox>
                        <SoftBox px={4} py={2} display="flex" flexDirection="column" justifyContent="center" alignItems="center"  >
                          <SoftTypography sx={{ pb: 3}} variant="body2" color="text" >
                            Select the timeframe to retrieve To-Do notes for patients seen during this period.
                          </SoftTypography>
                          <SoftSelect 
                            placeholder="Past 12 Hours (default)"
                            //success={ saveSuccess ? true : false }
                            value={selectedTimeFrame ? { value: selectedTimeFrame, label: selectedTimeFrame } : null}
                            onChange={handleSelectChange}
                            options={[
                              { value: "Past 4 Hours", label: "Past 4 Hours"},
                              { value: "Past 8 Hours", label: "Past 8 Hours"},
                              { value: "Past 12 Hours", label: "Past 12 Hours"},
                              { value: "Past 24 Hours", label: "Past 24 Hours"},
                              { value: "Past 48 Hours", label: "Past 48 Hours"},
                              { value: "Past 72 Hours", label: "Past 72 Hours"},
                              { value: "Past 4 Days", label: "Past 4 Days"},
                              { value: "Past 7 Days", label: "Past 7 Days"},
                            ]}
                            isClearable={true}
                            menuPortalTarget={document.body} // Render the dropdown menu as a portal appended to the body
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Adjust z-index as needed
                          />
                        </SoftBox>
                        <SoftBox pt={4} pb={2} >
                          < SeperatorNotes />
                        </SoftBox>
                        <SoftBox py={2} mb={2} display="flex" justifyContent="center" alignItems="center" >
                          <Tooltip
                            title={
                              ["Platinum Subscription", "Gold Subscription"].includes(currentUserSubscription)
                              ? "Retrieves all the patient plans for the selected timeframe"
                              : "This feature is available for Platinum and Gold Package subscribers only."
                            }
                            placement="right"
                          >
                            <span>
                              <SoftButton disabled={!["Platinum Subscription", "Gold Subscription"].includes(currentUserSubscription)} onClick={fetchAndDisplayTodoNotes} variant="contained" size="medium" color="dark" startIcon={ < GetAppOutlinedIcon />} >
                                Retrieve To-Do Notes
                              </SoftButton>
                            </span>
                          </Tooltip>
                        </SoftBox>
                        {!["Platinum Subscription", "Gold Subscription"].includes(currentUserSubscription) && (
                          <SoftBox px={4} sx={{ mb: 3}} display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
                            <SoftBadge
                                variant="contained"
                                color="error"
                                size="md"
                                badgeContent={
                                    <SoftTypography variant="button">
                                        🔔&nbsp;&nbsp;This feature is available for Platinum and Gold Package subscribers only.
                                    </SoftTypography>
                                }
                                container
                            />
                          </SoftBox>
                        )}
                        { openTODOContent && (
                          <>
                            <SoftBox pr={2} display="flex" justifyContent="flex-end" alignItems="center" >
                              <SoftButton onClick={handleCopyTodoNotes} startIcon={copyAllTemplate ? <CheckCircleOutlineOutlinedIcon /> : <ContentCopyOutlinedIcon />} variant={copyAllTemplate ? "outlined" : "contained"} color="dark" >
                                  {copyAllTemplate ? "Copied!" : "Copy All"}
                              </SoftButton>
                            </SoftBox>
                            <SoftBox p={2}>
                              <SoftInput
                                multiline
                                rows={15}
                                value={todoNotesContent}
                                onChange={handleTodoNotesChange}
                                placeholder="TODO notes will be shown here..."
                              />
                            </SoftBox>
                            { !openEmail ? (
                            <SoftBox mb={2} display="flex" justifyContent="center" alignItems="center" p={2} >
                              <SoftButton onClick={handleToggleEmail} variant="contained" color="dark" startIcon={ < ForwardToInboxOutlinedIcon /> } >
                                Send as email 
                              </SoftButton>
                            </SoftBox>
                            ) : (
                              <>
                              <SoftBox pt={4} >
                                < SeperatorEmail />
                              </SoftBox>
                              <SoftBox >
                                <Card raised>
                                    <SoftBox p={2}>
                                        <SoftBox mr={4} mt={2} display="flex" justifyContent="flex-end" >
                                          <Tooltip title="Closes email form, changes made are temporary saved during this session" placement="bottom" >
                                          <SoftButton onClick={handleToggleEmail} variant="outlined" color="dark" startIcon={ < CloseOutlinedIcon /> } >
                                            Close Email Modal
                                          </SoftButton>
                                          </Tooltip>
                                        </SoftBox>
                                        <SoftBox mt={0} ml={1} mb={1} display="flex" alignItems="center" justifyContent="flex-start">
                                            <SoftBadge
                                                variant="contained"
                                                color="warning"
                                                size="md"
                                                badgeContent={
                                                    <SoftTypography variant="h6">
                                                        Securely send the generated plans as an email
                                                    </SoftTypography>
                                                }
                                            />
                                        </SoftBox>
                                        <SoftBox mt={1} ml={1} mb={5} display="flex" flexDirection="column"  justifyContent="flex-start">
                                            <SoftTypography ml={1.5} mr={3} variant="body2" >
                                                This email will be send via our custom, white-labeled and HIPAA compliant service. 
                                            </SoftTypography>
                                            <SoftTypography ml={1.5} mr={3} variant="body2" >
                                                The receiver&apos;s email is deleted immediatly after the email has been send.
                                            </SoftTypography>
                                        </SoftBox>
                                        <SoftBox >
                                          <Card sx={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', mx:2, mb:3}} >
                                              <SoftBox p={2} display="flex" flexDirection="column" justifyContent="flex-start" >
                                                  <SoftTypography sx={{ mt:3}} variant="button" fontWeight="bold" ml={0.7} mb={1}>Email subject</SoftTypography>
                                                  <SoftInput
                                                      placeholder="Email Subject"
                                                      fullWidth
                                                      
                                                      value={emailSubject || ""}
                                                      onChange={(e) => setEmailSubject(e.target.value)}
                                                  />
                                                  <SoftTypography sx={{ mt:3}} variant="button" fontWeight="bold" ml={0.7} mb={1}>Email content</SoftTypography>
                                                  <SoftInput
                                                      placeholder="generated email content specific to this session"
                                                      fullWidth
                                                      multiline
                                                      rows={10}
                                                      
                                                      value={todoNotesContent}
                                                      onChange={handleTodoNotesChange}
                                                  />
                                                  <SoftTypography sx={{ mt:3}} variant="button" fontWeight="bold" ml={0.7} mb={1}>Sender name</SoftTypography>
                                                  <SoftInput
                                                      placeholder="your_email@example.com"
                                                      fullWidth
                                                      value={emailSenderName || senderName}
                                                      onChange={(e) => setEmailSenderName(e.target.value)}
                                                  />
                                                  <SoftTypography sx={{ mt:3}} variant="button" fontWeight="bold" ml={0.7} mb={1}>Receiver&apos;s email</SoftTypography>
                                                  <SoftInput
                                                      placeholder="Enter the receiver's email"
                                                      fullWidth
                                                      value={patientEmail}
                                                      onChange={(e) => setPatientEmail(e.target.value)}
                                                  />
                                              </SoftBox>
                                              <SoftBox px={2} pb={2} pt={2} display="flex" alignItems="center" justifyContent="flex-end" >
                                                  <Tooltip title={!patientEmail ? "Input a receiver's email address" : "send to receiver"} placement="top" >
                                                      <span>
                                                      <SoftButton disabled={!patientEmail} startIcon={<SendOutlinedIcon />} variant={patientEmail ? "contained" : "outlined" } color="dark" onClick={() => handleSendEmail()} >
                                                          Send this email 
                                                      </SoftButton>
                                                      </span>
                                                  </Tooltip>
                                              </SoftBox>
                                              
                                          </Card>
                                        </SoftBox>
                                    </SoftBox>
                                  </Card>
                              </SoftBox>
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </Card>
                </SoftBox>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} xl={6} className="joyride-recent-visits">
                {/*<LatestVisits userId={userIdentification} />*/}
                <Pages userId={userIdentification} />
              </Grid>
              <Grid item xs={12} md={6} xl={6} className="joyride-audio-usage">
                <DefaultDoughnutChart
                  title="Monthly Audio Usage Overview"
                  description={<span>Renews at <strong>{subscriptionEndDate}</strong></span>}
                  chart={defaultDoughnutChartData}
                  audioUsage={userAudioUsage} />
              </Grid>
              {/*<Grid item xs={12} md={6} xl={4}>
      <ProfileInfoCard
        title="profile information"
        description="Hi, I’m Alec Thompson, Decisions: If you can’t decide, the answer is no. If two equally difficult paths, choose the one more painful in the short term (pain avoidance is creating an illusion of equality)."
        info={{
          fullName: "Alec M. Thompson",
          mobile: "(44) 123 1234 123",
          email: "alecthompson@mail.com",
          location: "USA",
        }}
        social={[
          {
            link: "https://www.facebook.com/CreativeTim/",
            icon: <FacebookIcon />,
            color: "facebook",
          },
          {
            link: "https://twitter.com/creativetim",
            icon: <TwitterIcon />,
            color: "twitter",
          },
          {
            link: "https://www.instagram.com/creativetimofficial/",
            icon: <InstagramIcon />,
            color: "instagram",
          },
        ]}
        action={{ route: "", tooltip: "Edit Profile" }}
      />
    </Grid>
    <Grid item xs={12} xl={4}>
      <ProfilesList title="conversations" profiles={profilesListData} />
      </Grid>*/}
            </Grid>
          </SoftBox><SoftBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} xl={6}>
                  <SoftBox>
                    <PlatformSettings />
                  </SoftBox>
                  <SoftBox mt={2}>
                    <ChangePassword />
                  </SoftBox>
                </Grid>
                <Grid item xs={12} md={6} xl={6}>
                  <SoftBox mb={2} className="joyride-auto-delete">
                    <AutoDeletePatients  />
                  </SoftBox>
                  <SoftBox mb={2}>
                    <Authentication />
                  </SoftBox>
                  <SoftBox mb={2}>
                    <Logout />
                  </SoftBox>
                  <SoftBox>
                    <DeleteAccount />
                  </SoftBox>
                </Grid>
              </Grid>
            </SoftBox></>
      ) : (

        <SoftBox 
          display="flex" 
          justifyContent="center"
          alignItems="center"    
          flexDirection="column"
        >
          <Grid container spacing={3} justifyContent="center" >
            <Grid item xs={12} md={10} xl={11}>
              <FreeTrialPrompt />
              <SoftBox mt={8} mb={2}>
                <Logout />
              </SoftBox>
              <DeleteAccount />
            </Grid>
          </Grid >
        </SoftBox>
      )}

      <Footer />
      <SoftSnackbar
          //bgWhite="true"
          color={snackbar.color || "dark"}
          icon={snackbar.icon}
          title={snackbar.title}
          content={snackbar.message}
          open={snackbar.show}
          close={hideSnackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      />
      <Dialog
        open={showTutorialPrompt}
        onClose={handleSkipTutorial}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ '& .MuiDialog-paper': { padding: 2 } }}
      >
        <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }}>{"Start Tutorial?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" sx={{ margin: '20px', textAlign: 'center' }}>
            Would you like to take a quick tour of the key features of your dashboard?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSkipTutorial} sx={{ backgroundColor: '#344767', color: '#FFFFFF', '&:hover': { backgroundColor: '#2b395e', color: '#FFFFFF' }, padding: '8px 16px' }}>
            No thanks
          </Button>
          <Button onClick={handleStartTutorial} sx={{ backgroundColor: '#344767', color: '#FFFFFF', '&:hover': { backgroundColor: '#2b395e', color: '#FFFFFF' }, padding: '8px 16px' }} >
            Start Tutorial
          </Button>
        </DialogActions>
      </Dialog>
      <Joyride
        continuous
        run={isJoyrideOpen}
        steps={steps}
        spotlightPadding={10}
        scrollToFirstStep
        showProgress
        showSkipButton
        autoStart
        styles={{
          options: {
            zIndex: 10000,
            arrowColor: '#ffffff',
            backgroundColor: '#ffffff',
            //overlayColor: 'rgba(79, 26, 0, 0)',
            primaryColor: '#344767',
            textColor: '#333',
            spotlightPadding: 10,
            borderRadius: '12px',
          }, 
          buttonNext: {
            backgroundColor: '#344767', 
            color: '#ffffff',
            borderRadius: '12px',
            padding: '8px 16px'
          },
          buttonBack: {
            backgroundColor: '#344767', 
            color: '#ffffff',
            borderRadius: '12px',
            padding: '8px 16px'
          },
          buttonSkip: {
            backgroundColor: '#e9ecef',
            color: '#344767',
            borderRadius: '12px',
            padding: '8px 16px'
          },
        }}
      />
    </DashboardLayout>
  );
}

export default Overview;
